import { Breakpoint, Button, Color, Typography } from '@elearning-platform/ui';
import { styled } from 'styled-components';

export const Wrapper = styled.div`
  padding: 40px 16px;
  background-color: ${Color.Gray100};

  @media ${Breakpoint.SmallDesktop} {
    padding: 40px 24px;
  }
`;

export const VideosWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 40px;
`;

export const HeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 15px;
  border-bottom: 2px solid ${Color.Brand300};
`;

export const StyledHeaderTypography = styled(Typography)`
  color: ${Color.Gray600};
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 40px;

  @media ${Breakpoint.SmallDesktop} {
    flex-direction: row;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media ${Breakpoint.SmallDesktop} {
    max-width: 674px;
    gap: 40px;
    padding: 43px 0;
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;

  @media ${Breakpoint.SmallDesktop} {
    margin-bottom: 0;
  }
`;

export const Image = styled.img`
  width: 100%;
  max-width: 462px;
  max-height: 362px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 24px;
  flex-direction: column;

  @media ${Breakpoint.SmallDesktop} {
    flex-direction: row;
  }
`;

export const StyledButton = styled(Button)`
  align-self: baseline;
`;

export const VideoDivider = styled.div`
  width: 100%;
  border-bottom: 1px solid ${Color.Gray300};
  margin: 40px 0;
`;
